"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = exports.ModalContent = exports.ClearButton = exports.ModalControl = exports.Wrapper = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _polished = require("polished");
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Modalstyle__Wrapper",
  componentId: "sc-3t31ot-0"
})(["background-color:", ";height:100%;left:0;opacity:", ";position:fixed;top:0;transition:all ", ";width:100%;z-index:1000;@media (min-width:", "){background-color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.modal.overlayColorMobile;
}, function (_ref2) {
  var state = _ref2.state;
  return state === 'entered' ? '1' : '0';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.animation.transitionFast;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.sm;
}, function (_ref5) {
  var theme = _ref5.theme;
  return (0, _polished.rgba)(theme.modal.overlayColorDesktop, 0.85);
});
exports.Wrapper = Wrapper;
var ModalControl = _styledComponents.default.div.withConfig({
  displayName: "Modalstyle__ModalControl",
  componentId: "sc-3t31ot-1"
})(["display:flex;justify-content:flex-end;width:100%;position:sticky;top:0;box-shadow:", ";background-color:", ";height:", ";z-index:10;@media (min-width:", "){height:", ";}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.modal.topBarShadow;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.modal.topBarColor;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.modal.topBarSizeMobile;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.sm;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.modal.topBarSizeDesktop;
});
exports.ModalControl = ModalControl;
var ClearButton = _styledComponents.default.button.withConfig({
  displayName: "Modalstyle__ClearButton",
  componentId: "sc-3t31ot-2"
})(["align-items:center;cursor:pointer;display:flex;height:", ";justify-content:center;padding:0 ", ";width:", ";"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.modal.topBarSize;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.space.md;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.modal.topBarSize;
});
exports.ClearButton = ClearButton;
var ModalContent = _styledComponents.default.div.withConfig({
  displayName: "Modalstyle__ModalContent",
  componentId: "sc-3t31ot-3"
})(["max-height:100%;max-width:100%;padding:", ";position:relative;"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.modal.modalPadding;
});
exports.ModalContent = ModalContent;
var Container = _styledComponents.default.div.withConfig({
  displayName: "Modalstyle__Container",
  componentId: "sc-3t31ot-4"
})(["position:absolute;top:50%;left:50%;opacity:0;transform:translate(-50%,-45%) scale(0.99);background-color:", ";width:100%;height:100%;box-shadow:", ";overflow-y:auto;-webkit-overflow-scrolling:touch;transition:all ", ";", " @media (min-width:", "){border-radius:", ";height:auto;max-height:100%;position:fixed;width:", ";max-width:100%;}"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.modal.modalInnerColor;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.modal.boxShadow;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.animation.transitionSlow;
}, function (_ref18) {
  var state = _ref18.state;
  switch (state) {
    case 'entered':
      return (0, _styledComponents.css)(["opacity:1;transform:translate(-50%,-50%);"]);
  }
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.breakpoints.sm;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.modal.radius;
}, function (_ref21) {
  var theme = _ref21.theme,
    size = _ref21.size;
  return theme.breakpoints[size];
});
exports.Container = Container;